import { useTranslation } from 'react-i18next';
import { Alert } from 'antd';
import { BankOutlined } from '@ant-design/icons';
import styles from './client-factoring-alert.module.scss';

export const ClientFactoringAlert = () => {
  const { t } = useTranslation('client');

  return (
    <Alert
      className={styles.alert}
      icon={
        <span className={styles.icon}>
          <BankOutlined />
        </span>
      }
      message={<strong>{t('factoring_client')}</strong>}
      description={t('factoring_client_description')}
      showIcon
    />
  );
};
